import React from 'react'

type PropsT = {
  className?: string
  // Interior fill — defaults to transparent (outline-only star). Pass a
  // color to render a filled star (e.g. the favorited state).
  fillColor?: string
  // Outline color — independent of fillColor so a filled star can still
  // have a differently-colored border (e.g. yellow fill, grey border).
  strokeColor?: string
}
const Star: React.FC<PropsT> = props => {
  const { className, fillColor = 'none', strokeColor = 'currentColor' } = props

  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M6.72292 1.33853C6.74848 1.28688 6.78797 1.2434 6.83693 1.21301C6.88589 1.18261 6.94237 1.1665 7 1.1665C7.05763 1.1665 7.11411 1.18261 7.16307 1.21301C7.21203 1.2434 7.25152 1.28688 7.27709 1.33853L8.62458 4.06794C8.71336 4.24759 8.84439 4.40301 9.00645 4.52087C9.16851 4.63873 9.35674 4.71551 9.555 4.74461L12.5685 5.18561C12.6256 5.19388 12.6792 5.21797 12.7234 5.25514C12.7675 5.29232 12.8003 5.34109 12.8182 5.39596C12.836 5.45083 12.8382 5.5096 12.8243 5.56561C12.8105 5.62163 12.7813 5.67266 12.74 5.71294L10.5607 7.83511C10.4169 7.97517 10.3094 8.14806 10.2473 8.33889C10.1852 8.52973 10.1705 8.73279 10.2043 8.93061L10.7188 11.9289C10.7288 11.986 10.7227 12.0448 10.701 12.0985C10.6793 12.1522 10.6429 12.1988 10.596 12.2329C10.5491 12.2669 10.4936 12.2871 10.4358 12.2911C10.3779 12.2952 10.3202 12.2828 10.269 12.2556L7.57517 10.8393C7.39767 10.7461 7.20019 10.6974 6.99971 10.6974C6.79923 10.6974 6.60175 10.7461 6.42425 10.8393L3.731 12.2556C3.67986 12.2827 3.62215 12.2949 3.56443 12.2908C3.50671 12.2867 3.4513 12.2664 3.40451 12.2324C3.35771 12.1984 3.3214 12.1519 3.29972 12.0982C3.27803 12.0446 3.27184 11.9859 3.28184 11.9289L3.79575 8.93119C3.8297 8.73329 3.81499 8.53009 3.7529 8.33914C3.69081 8.14818 3.58319 7.9752 3.43934 7.83511L1.26 5.71353C1.21835 5.67329 1.18883 5.62217 1.17481 5.56599C1.1608 5.5098 1.16284 5.4508 1.18071 5.39572C1.19859 5.34064 1.23157 5.29168 1.27591 5.25443C1.32025 5.21718 1.37416 5.19313 1.4315 5.18503L4.44442 4.74461C4.6429 4.71573 4.8314 4.63906 4.99368 4.52118C5.15596 4.40331 5.28716 4.24777 5.376 4.06794L6.72292 1.33853Z"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Star
